import { listSelectableSkills } from '#pplx/frontend/apps/ask/skills/hooks/internal/listSelectableSkills.js';
export async function getSelectableSkillById(skillId, reason) {
    const response = await listSelectableSkills({ app: 'computer', limit: 20, query: skillId }, reason);
    return response.skills.find((skill) => skill.id === skillId);
}
//# sourceMappingURL=getSelectableSkillById.js.map